"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("listing-activity-list", className, styles.root),
        items: styling_1.mergeStyles("listing-activity-list-items", styles.items),
        itemsGroupHeader: styling_1.mergeStyles("listing-activity-list-items-group-header", styles.itemsGroupHeader)
    };
});
exports.getClassNames = getClassNames;
